// extracted by mini-css-extract-plugin
module.exports = {"mentionContainer":"antd-pro-containers-emails-styles-mentionContainer","focus":"antd-pro-containers-emails-styles-focus","quoteAdd":"antd-pro-containers-emails-styles-quoteAdd"};